import * as React from 'react';
import { composer } from '../../../component-decorators/composer';
import { Card, CounterBadge, Box, Heading } from 'wix-style-react';
export var CompleteSetupHeader = composer()
    .withTranslation()
    .withExperiments()
    .compose(function (_a) {
    var t = _a.t, badgeCounter = _a.badgeCounter, experiments = _a.experiments;
    return (React.createElement(Card.Header, { title: React.createElement(Box, { verticalAlign: 'middle' },
            React.createElement(Box, { marginRight: '10px' },
                React.createElement(Heading, { appearance: "H3", dataHook: "manage-apps-pending-title" }, t('manage-apps.complete-setup-apps.card-header.action-required'))),
            React.createElement(CounterBadge, { skin: 'danger', dataHook: "manage-apps-counter-badge" }, badgeCounter)) }));
});
//# sourceMappingURL=complete-setup.apps-section-header.js.map